import {
  reactive, ref, toRef, watch,
} from '@vue/composition-api'
import formatDate from '@/utils/date-format'

export default function usePromoCodesList(ctx) {
  const tableColumns = [
    { key: 'code' },
    {
      key: 'effective_date_time',
      label: 'effective date',
      formatter: val => formatDate(val),
    },
    {
      key: 'expiry_date_time',
      label: 'expiry date',
      formatter: val => formatDate(val),
    },
    { key: 'active', label: 'Status' },
    {

      key: 'first_trip_only',
      label: 'is first trip',

    },
    {
      key: 'max_amount',
      label: 'max amount',
    },
    {
      key: 'per_user',
      label: 'use per user',
    },
    {
      key: 'budgeted_amount', label: 'budgeted amount',
    },
    { key: 'current_usage_count', label: 'currently used usage' },
    { key: 'current_amount', label: 'currently used amount' },
    { key: 'rate', label: 'type' },
  ]
  const promoCodesList = ref([])
  const loading = ref(false)
  const effectiveDate = ref()
  const expiryDate = ref()
  const queryParams = reactive({
    page: 1,
    per_page: 10,
    code: undefined,
  })
  const total = ref(0)
  const fetchPromoCodes = async () => {
    try {
      loading.value = true

      const paramsTemp = {
        page: queryParams.page,
        per_page: queryParams.per_page,
        code: queryParams.code || undefined,
        effective_date_time: effectiveDate.value,
        expiry_date_time: expiryDate.value,
      }

      queryParams.effective_date_time = effectiveDate
      const response = await ctx.root.$store.dispatch('promoCodes/fetchPromoCodesList', paramsTemp)
      total.value = response.data.data.total
      promoCodesList.value = response.data.data.promo_codes.map(el => ({
        ...el,
        ...el.criteria,
        ...el.criteria.retry,
        ...el.criteria.value,
      }))
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  fetchPromoCodes()

  watch([toRef(queryParams, 'page'), toRef(queryParams, 'per_page')], () => {
    fetchPromoCodes()
  })

  const resetFilters = () => {
    effectiveDate.value = undefined
    expiryDate.value = undefined
    queryParams.code = undefined
    fetchPromoCodes()
  }

  return {
    tableColumns,
    promoCodesList,
    total,
    resetFilters,
    fetchPromoCodes,
    effectiveDate,
    expiryDate,
    loading,
    queryParams,
  }
}
